import React from 'react';
import { Typography } from '@cp/ds/src/components/typography';
import { PromocodeViewModel } from '@common/model/billing/promocode';
import { formatPromocodeFreePeriod } from '@cp/entities/promocode';
import { Box, BoxProps } from '@cp/ds/src/components/box';
import { styled } from '@cp/ds/src/theme';
import { GiftImage, GiftImageProps } from './gitftImage';

const Root = styled(Box, { name: 'PromocodeActivatedMessage' })({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: '12px',
});

export interface PromocodeActivatedMessageProps extends BoxProps {
  promocode: PromocodeViewModel;
  imageProps?: GiftImageProps;
}
export const PromocodeActivatedMessage: React.FC<PromocodeActivatedMessageProps> = ({ promocode, imageProps }) => {
  return (
    <Root>
      <GiftImage size={50} {...imageProps} />
      <Box>
        <Typography variant="body bold">
          Мы подарим вам{' '}
          <Typography sx={{ color: 'brand pink' }} variant="body bold">
            {formatPromocodeFreePeriod(promocode)} бесплатно
          </Typography>{' '}
          по промокоду!{' '}
          <Typography sx={{ color: 'grey' }} variant="body">
            Не забудьте привязать карту.
          </Typography>
        </Typography>
      </Box>
    </Root>
  );
};
